// Mutable shared state. Imported by render/legacy code.
// Keep tiny — only what genuinely needs to be cross-module.

import { CURRENT_MONTH } from './constants.js';

export const state = {
  selRole: null,
  selMonth: CURRENT_MONTH,
  bonusInputs: {},
  actuals: {},          // { [roleKey]: { [kpiIdx]: value } }
  PL_ACT: {},           // actual monthly P&L totals keyed by month 1..12
  ROLE_EMAILS: {},      // { [roleKey]: email }
  GMV_FC_CUSTOM: null,  // user-edited H2 forecast (overrides constants.GMV_FC for H2 months)
};

// Accessor used by calc.weightedScore
export const getAct = (key, idx) => (state.actuals[key] || {})[idx];

export function setAct(key, idx, v) {
  if (!state.actuals[key]) state.actuals[key] = {};
  state.actuals[key][idx] = v;
}
